<div *ngIf="notifications$ | async as notifications" class="notifications-container">
  <div *ngFor="let notification of notifications;trackBy: trackById" [@flyInOut]="'in'">
    <app-notification [notification]="notification"></app-notification>
  </div>
</div>
